import { interpretarBusca } from '@metaepi/shared';
import { Search } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { Botao, Campo } from '../../components/ui';

/** Id do campo de busca: o atalho ⌘K / Ctrl+K (Layout) foca este campo. */
export const ID_BUSCA_GESTANTE = 'busca-gestante';

const DICA = 'CPF, CNS, data de nascimento (dd/mm/aaaa) ou parte do nome. Atalho: Ctrl K.';

/**
 * Campo único de busca. Só pesquisa ao confirmar (Enter ou botão): cada busca é
 * registrada na auditoria, então não buscamos a cada letra digitada.
 */
export function BuscaGestante({
  inicial = '',
  aoBuscar,
  buscando,
}: {
  inicial?: string;
  aoBuscar: (termo: string) => void;
  buscando: boolean;
}) {
  const [termo, setTermo] = useState(inicial);
  const [erro, setErro] = useState<string>();

  const enviar = (e: FormEvent) => {
    e.preventDefault();
    if (!interpretarBusca(termo)) {
      setErro(
        'Digite o CPF ou o CNS completo, a data de nascimento (dd/mm/aaaa) ou pelo menos 3 letras do nome.',
      );
      return;
    }
    setErro(undefined);
    aoBuscar(termo.trim());
  };

  return (
    <form
      role="search"
      onSubmit={enviar}
      className="flex flex-col gap-2 sm:flex-row sm:items-start"
    >
      <div className="flex-1">
        <Campo
          id={ID_BUSCA_GESTANTE}
          rotulo="Buscar gestante"
          type="search"
          autoComplete="off"
          // A busca é o objetivo principal desta tela
          autoFocus
          value={termo}
          onChange={(e) => setTermo(e.target.value)}
          dica={erro ? undefined : DICA}
          erro={erro}
        />
      </div>
      <Botao type="submit" carregando={buscando} className="sm:mt-7">
        <Search className="size-4" aria-hidden="true" />
        Buscar
      </Botao>
    </form>
  );
}
